import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSURL` scalar type provided by AWS AppSync, represents a valid URL string (Ex: <https://www.amazon.com/>). The URL may use any scheme and may also be a local URL (Ex: <http://localhost/>).  URLs without schemes like "**amazon.com**" or "**www.amazon.com**" are considered invalid. URLs which contain double slashes (two consecutive forward slashes) in their path are also considered invalid. */
  AWSURL: any;
};










export type Account = {
  __typename?: 'Account';
  name: Scalars['String'];
};

export type AccountList = {
  __typename?: 'AccountList';
  data: Array<Maybe<Account>>;
  page?: Maybe<Page>;
};


export type Client = {
  __typename?: 'Client';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
};

export type FeedPeriod = {
  __typename?: 'FeedPeriod';
  FEED_NAME: Scalars['String'];
  END_PERIOD_DATE: Scalars['String'];
};

export type GetAffiliateLinkInput = {
  retailerId: Scalars['String'];
  subId1: Scalars['String'];
  subId2: Scalars['String'];
  bareUrl: Scalars['String'];
};

export type HeliosProduct = {
  __typename?: 'HeliosProduct';
  name: Scalars['String'];
  upc: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  updateProductLinks?: Maybe<Scalars['String']>;
};


export type MutationUpdateProductLinksArgs = {
  input: UpdateProductLinkInput;
};

export type Page = {
  __typename?: 'Page';
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
  currentPage: Scalars['Int'];
};

export type PageableInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortedBy?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<SortDirection>;
  search?: Maybe<Scalars['String']>;
  searchBy?: Maybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated Field is deprecated! */
  description?: Maybe<Scalars['String']>;
  upc?: Maybe<Array<Maybe<Upc>>>;
  /** @deprecated Field is deprecated! */
  status?: Maybe<Status>;
  /** @deprecated Field is deprecated! */
  links?: Maybe<Array<Maybe<Scalars['AWSURL']>>>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  items?: Maybe<Array<Maybe<Product>>>;
  /** @deprecated Field is deprecated! */
  nextToken?: Maybe<Scalars['String']>;
  page?: Maybe<Page>;
};

export type ProductLink = {
  __typename?: 'ProductLink';
  client?: Maybe<Scalars['String']>;
  GTIN?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  retailer_id?: Maybe<Scalars['Int']>;
  retailer_name?: Maybe<Scalars['String']>;
};

export type ProductLinkResponse = {
  __typename?: 'ProductLinkResponse';
  timestamp?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  res?: Maybe<Scalars['Int']>;
};

export type ProductList = {
  __typename?: 'ProductList';
  data: Array<Maybe<HeliosProduct>>;
  page?: Maybe<Page>;
};

export type Query = {
  __typename?: 'Query';
  getProduct?: Maybe<Product>;
  listProducts?: Maybe<ProductConnection>;
  batchListProductsHelios?: Maybe<ProductConnection>;
  listProductsLinks?: Maybe<Array<Maybe<ProductLink>>>;
  archiveClient?: Maybe<Scalars['String']>;
  getAffiliateLink?: Maybe<Scalars['String']>;
  listClients?: Maybe<Array<Maybe<Client>>>;
  accounts?: Maybe<AccountList>;
  stores?: Maybe<StoreList>;
  products?: Maybe<ProductList>;
  states?: Maybe<StateList>;
  listFeedPeriod?: Maybe<Array<Maybe<FeedPeriod>>>;
  batchListProducts?: Maybe<ProductConnection>;
  getStore?: Maybe<Array<Maybe<Store>>>;
};


export type QueryGetProductArgs = {
  id: Scalars['ID'];
};


export type QueryListProductsArgs = {
  client: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QueryBatchListProductsHeliosArgs = {
  client: Scalars['String'];
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type QueryListProductsLinksArgs = {
  client?: Maybe<Scalars['String']>;
};


export type QueryArchiveClientArgs = {
  client?: Maybe<Scalars['String']>;
};


export type QueryGetAffiliateLinkArgs = {
  input: GetAffiliateLinkInput;
};


export type QueryAccountsArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageable?: Maybe<PageableInput>;
};


export type QueryStoresArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageable?: Maybe<PageableInput>;
};


export type QueryProductsArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageable?: Maybe<PageableInput>;
};


export type QueryStatesArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageable?: Maybe<PageableInput>;
};


export type QueryListFeedPeriodArgs = {
  client: Scalars['String'];
};


export type QueryBatchListProductsArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pageable?: Maybe<PageableInput>;
};


export type QueryGetStoreArgs = {
  client: Scalars['String'];
  spinsTag?: Maybe<Scalars['String']>;
  nielsenTag?: Maybe<Scalars['String']>;
  storeTag?: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type State = {
  __typename?: 'State';
  code: Scalars['String'];
};

export type StateList = {
  __typename?: 'StateList';
  data: Array<Maybe<State>>;
  page?: Maybe<Page>;
};

export enum Status {
  Active = 'active',
  Inactive = 'inactive',
  Prerelease = 'prerelease',
  Discontinued = 'discontinued'
}

export type Store = {
  __typename?: 'Store';
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  subpremise?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  spinsTag?: Maybe<Scalars['String']>;
  nielsenTag?: Maybe<Scalars['String']>;
  storeTag?: Maybe<Scalars['String']>;
};

export type StoreList = {
  __typename?: 'StoreList';
  data: Array<Maybe<Store>>;
  page?: Maybe<Page>;
};

export type TableBooleanFilterInput = {
  ne?: Maybe<Scalars['Boolean']>;
  eq?: Maybe<Scalars['Boolean']>;
};

export type TableFloatFilterInput = {
  ne?: Maybe<Scalars['Float']>;
  eq?: Maybe<Scalars['Float']>;
  le?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  ge?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  contains?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type TableIdFilterInput = {
  ne?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  le?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  ge?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
  beginsWith?: Maybe<Scalars['ID']>;
};

export type TableIntFilterInput = {
  ne?: Maybe<Scalars['Int']>;
  eq?: Maybe<Scalars['Int']>;
  le?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  ge?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  contains?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type TableProductFilterInput = {
  id?: Maybe<TableIdFilterInput>;
  name?: Maybe<TableStringFilterInput>;
  description?: Maybe<TableStringFilterInput>;
  ingredientsList?: Maybe<TableStringFilterInput>;
  msrp?: Maybe<TableFloatFilterInput>;
  quantity?: Maybe<TableFloatFilterInput>;
  size?: Maybe<TableStringFilterInput>;
  brickMortar?: Maybe<TableBooleanFilterInput>;
  onLine?: Maybe<TableBooleanFilterInput>;
};

export type TableStringFilterInput = {
  ne?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
  beginsWith?: Maybe<Scalars['String']>;
};

export type Upc = {
  __typename?: 'UPC';
  id: Scalars['ID'];
  value: Scalars['String'];
  type?: Maybe<UpcType>;
};

export enum UpcType {
  Gtin = 'GTIN',
  Upca = 'UPCA',
  Upce = 'UPCE',
  Ean13 = 'EAN13',
  Ean8 = 'EAN8'
}

export type UpdateProductLinkInput = {
  clientId: Scalars['String'];
  retailerSite: Scalars['String'];
  retailerId: Scalars['String'];
  upc: Scalars['String'];
  sku: Scalars['String'];
  availability: Scalars['String'];
  affiliateUrl: Scalars['String'];
  bareUrl: Scalars['String'];
  price: Scalars['String'];
  offers: Scalars['String'];
};

export type ListFeedPeriodQueryVariables = Exact<{
  clientID: Scalars['String'];
}>;


export type ListFeedPeriodQuery = (
  { __typename?: 'Query' }
  & { listFeedPeriod?: Maybe<Array<Maybe<(
    { __typename?: 'FeedPeriod' }
    & Pick<FeedPeriod, 'FEED_NAME' | 'END_PERIOD_DATE'>
  )>>> }
);

export type GetStoresQueryVariables = Exact<{
  clientID: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  pageable?: Maybe<PageableInput>;
}>;


export type GetStoresQuery = (
  { __typename?: 'Query' }
  & { stores?: Maybe<(
    { __typename?: 'StoreList' }
    & { data: Array<Maybe<(
      { __typename: 'Store' }
      & Pick<Store, 'address' | 'city' | 'name' | 'nielsenTag' | 'postalCode' | 'spinsTag' | 'state' | 'storeTag' | 'streetNumber'>
    )>>, page?: Maybe<(
      { __typename?: 'Page' }
      & Pick<Page, 'currentPage' | 'totalItems'>
    )> }
  )> }
);

export type GetProductsQueryVariables = Exact<{
  clientID: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  pageable?: Maybe<PageableInput>;
}>;


export type GetProductsQuery = (
  { __typename?: 'Query' }
  & { products?: Maybe<(
    { __typename?: 'ProductList' }
    & { data: Array<Maybe<(
      { __typename?: 'HeliosProduct' }
      & Pick<HeliosProduct, 'name' | 'upc'>
    )>>, page?: Maybe<(
      { __typename?: 'Page' }
      & Pick<Page, 'currentPage' | 'totalItems'>
    )> }
  )> }
);


export const ListFeedPeriodDocument = gql`
    query listFeedPeriod($clientID: String!) {
  listFeedPeriod(client: $clientID) {
    FEED_NAME
    END_PERIOD_DATE
  }
}
    `;
export type ListFeedPeriodQueryResult = Apollo.QueryResult<ListFeedPeriodQuery, ListFeedPeriodQueryVariables>;
export const GetStoresDocument = gql`
    query GetStores($clientID: String!, $brand: String, $stores: [String], $pageable: PageableInput) {
  stores(client: $clientID, brand: $brand, stores: $stores, pageable: $pageable) {
    data {
      __typename
      address
      city
      name
      nielsenTag
      postalCode
      spinsTag
      state
      storeTag
      streetNumber
    }
    page {
      currentPage
      totalItems
    }
  }
}
    `;
export type GetStoresQueryResult = Apollo.QueryResult<GetStoresQuery, GetStoresQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($clientID: String!, $brand: String, $products: [String], $pageable: PageableInput) {
  products(client: $clientID, brand: $brand, products: $products, pageable: $pageable) {
    data {
      name
      upc
    }
    page {
      currentPage
      totalItems
    }
  }
}
    `;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;